import { createStyles } from 'antd-style';

import { ThemeColors, ThemeFont, hexToRgbaWithAlpha } from '../../../theme';

export const useNewShipmentFlightInformationFormStyles = createStyles(
  ({ token }) => ({
    newShipmentAirRetrieval: {
      '.Accordion': {
        padding: '26px 20px 8px 20px',

        '.Accordion__Header': {
          textTransform: 'uppercase',
        },

        '.ant-btn-default': {
          color: `${token.colorPrimary} !important`,
          marginBottom: token.marginXS,
        },

        '.air-retrieval-airport-route > .ant-row:last-child': {
          marginTop: token.marginSM,
        },

        '#flight-search, #add-manual-flight': {
          float: 'right',

          '&[disabled]': {
            opacity: 0.5,
          },
        },
      },
    },
    flightSummaryContainer: {
      padding: '26px 20px 8px 20px',

      '.ant-row:last-child > .ant-form-item': {
        marginTop: token.marginXS,
      },
    },
    flightSummaryLabel: {
      fontFamily: ThemeFont.FONT_CONDENSED,
      fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
      color: ThemeColors.COLOR_GREY6,
      fontWeight: 700,
    },
    flightSummaryValue: {
      fontFamily: token.fontFamily,
      fontSize: ThemeFont.FONT_SIZE_LG_MINUS,
      color: ThemeColors.COLOR_BLACK,
      fontWeight: 500,
    },
    addFlightButton: {
      justifyItems: 'flex-end',

      '.ant-form-item-explain-error': {
        textAlign: 'right',
      },
    },
    flightsPopoverOverlay: {
      '&&': {
        '.ant-popover-inner': {
          backgroundColor: token.colorWhite,
        },
      },
    },
    searchFlightsPopoverContent: {
      width: 715,

      '.ant-table-body::-webkit-scrollbar': {
        minWidth: 'initial !important',
        minHeight: 'initial !important',
      },

      '.ant-table-tbody > tr > td, .ant-table-thead > tr > th': {
        padding: 0,
        border: 0,
        backgroundColor: token.colorWhite,
      },

      '.ant-table-thead > tr > th': {
        fontFamily: ThemeFont.FONT_CONDENSED,
        fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
        color: ThemeColors.COLOR_GREY6,
        fontWeight: 700,

        '&::before': {
          content: 'none',
        },
      },

      '.ant-table-tbody > tr > td': {
        fontFamily: token.fontFamily,
        fontSize: ThemeFont.FONT_SIZE_LG_MINUS,
        color: ThemeColors.COLOR_BLACK,
        fontWeight: 500,
      },
    },
    flightsTableRow: {
      height: 30,
      cursor: 'pointer',

      '&:hover > .ant-table-cell': {
        backgroundColor: hexToRgbaWithAlpha(ThemeColors.COLOR_BLUE3, 0.26),
      },
    },
  })
);
